var AddImage = function (key, config) {
    this.imageManager.add(key, config);
    return this;
}

export default AddImage;